import React, {Component} from 'react';
import {Row, Card, Breadcrumb, Spin} from 'antd';
import {Link} from 'react-router-dom';
import {api, app} from "../../app";

class Class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data_loading: true,
            classList: [],
        };
        this.dataSource();
    }

    componentDidMount() {
        this._isMounted = true;
        this.dataSource();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 数据源
     */
    dataSource() {
        const _this = this;
        app.post(api.ClassList).then(({flag, data, msg}) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    _this.setState({classList: data});
                } else {
                    app.alert(msg, "error");
                }
                _this.setState({data_loading: false});
            }
        });
    }

    handleClssClick(id) {
        this.props.history.push(`/feedback/list/${id}`);
    }

    render() {
        const classList = this.state.classList, loading = this.state.data_loading;
        return <div id="feedback_content">
            <div className="top-title">反馈<span>Feedback</span></div>
            <Breadcrumb separator=">" className="breadcrumb">
                <Breadcrumb.Item><Link to="/">首页</Link></Breadcrumb.Item>
                <Breadcrumb.Item>反馈</Breadcrumb.Item>
            </Breadcrumb>
            {loading ?
                (<Row type="flex" align="middle" justify="center" className="data_loading"><Spin tip="正在加载中..."></Spin></Row>)
                :
                (<Row type="flex" className="classlist">
                    {
                        classList.map((item, index) => {
                            return (
                                <Card key={index + 1} onClick={() => {
                                    this.handleClssClick(item.id)
                                }} className="class">
                                    <p>{item.class_name}</p>
                                </Card>
                            )
                        })
                    }
                </Row>)
            }
        </div>
    }
}

export default Class;



// WEBPACK FOOTER //
// ./src/routes/feedback/Class.jsx